import { YStack, XStack, Text } from "tamagui";
import type { LastOrder } from "@screen/Home/pages/GasShop/products";
import { useOrder } from "@utils/store/cart/useOrder";
import { kiosk } from "../kioskTheme";
import { useKiosk } from "../useKiosk";

/** 「上次訂購」卡：列出上次品項並提供一鍵重訂。無可重訂品項時不顯示。 */
const ReorderCard = ({ lastOrder, onReorder }: { lastOrder: LastOrder | null; onReorder: () => void }) => {
  // 瓦斯行隱藏金額或營業客戶時，重訂卡不顯示價格
  const { hideAmountOnPending } = useOrder();
  const { hidePrice } = useKiosk();
  const hideMoney = hideAmountOnPending || hidePrice;
  const items = (lastOrder?.gas_list || []).filter((it) => it.install_location);
  if (items.length === 0) return null;

  return (
    <YStack
      backgroundColor={kiosk.card}
      borderWidth={1}
      borderColor={kiosk.line}
      borderRadius={16}
      p={16}
      mb={16}
      cursor="pointer"
      onPress={onReorder}
      pressStyle={{ scale: 0.99 }}
      style={{ boxShadow: "0 6px 16px -12px rgba(20,40,90,.4)" }}>
      <Text fontSize={13} fontWeight="800" color={kiosk.blue} mb={8} letterSpacing={0.5}>
        ↻ 上次訂購
      </Text>
      <YStack gap={5}>
        {items.map((it, idx) => (
          <XStack key={idx} jc="space-between" gap={10}>
            <Text fontSize={15} fontWeight="600" color="#2a3550">
              {it.gas_type} · {it.kilogram}KG ×{it.qty}
            </Text>
            {!hideMoney && (
              <Text fontSize={15} fontWeight="800" color={kiosk.blueD}>
                NT${(it.unit_price * it.qty).toLocaleString()}
              </Text>
            )}
          </XStack>
        ))}
      </YStack>
      {!hideMoney && (
        <Text fontSize={11} color={kiosk.grey} mt={8}>
          ● 金額為上次訂購原價，優惠券折扣將於結帳頁套用
        </Text>
      )}
      <XStack
        className="gas-press"
        backgroundColor={kiosk.blue}
        borderRadius={999}
        py={13}
        mt={12}
        ai="center"
        jc="center"
        cursor="pointer"
        style={{ boxShadow: "0 2px 8px -4px rgba(29,111,255,.45)" }}>
        <Text color="#fff" fontSize={15} fontWeight="800">
          一鍵重新訂購 ›
        </Text>
      </XStack>
    </YStack>
  );
};

export default ReorderCard;
